import { Dialog, DialogType, DirectionalHint, IDialogProps } from '@fluentui/react';

export interface IPDialogProps extends IDialogProps {}
export { DialogType as IPDialogType, DirectionalHint as IPDirectionalHint };

export const IPDialog = (props: IPDialogProps) => {
  return <Dialog {...props} />;
};
